import { sameNodePosition, } from "../../components/markdown/utils";
import React, { memo } from "react";
export const StrongBlock = memo(({ children }) => (React.createElement("strong", { className: "s-font-semibold s-text-foreground dark:s-text-foreground-night" }, children)), (prev, next) => sameNodePosition(prev.node, next.node));
StrongBlock.displayName = "StrongBlock";
//# sourceMappingURL=StrongBlock.js.map